import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isCookiesAccepted } from 'react-wavecoder-components';

import { useConfig } from './useConfig';
import ga from '../utils/analytics';

export const useAnalytics = () => {
  const location = useLocation();
  const { config } = useConfig();

  useEffect(() => {
    if (config?.analytics?.measurementId) {
      if (isCookiesAccepted()) {
        ga.setMeasurementId(config.analytics.measurementId);
        ga.initialise();
      } else {
        ga.disable();
      }
    }
  }, [config?.analytics?.measurementId]);

  useEffect(() => {
    if (ga.isInitialised() && isCookiesAccepted()) {
      ga.trackPageView(location.pathname);
    }
  }, [location.pathname]);

  return {
    trackEvent: (eventName: string, parameters?: Record<string, any>) => {
      ga.trackEvent(eventName, parameters);
    },
    trackCustomEvent: (action: string, category: string, label?: string, value?: number) => {
      ga.trackCustomEvent(action, category, label, value);
    },
  };
};
